import { createAsyncThunk } from '@reduxjs/toolkit';
import { clearStorage, saveToStorage } from './storage';

export function createSaveFiltersThunk(storageKey: string, actionType: string) {
    return createAsyncThunk<Array<Array<string>>, Array<Array<string>>>(
        actionType,
        async (filters) => {
            if (!filters) {
                throw new Error('No filters received');
            }
            saveToStorage(storageKey, filters);
            return filters;
        },
    );
}

export function createClearFiltersThunk(
    storageKey: string,
    actionType: string,
) {
    return createAsyncThunk<void, void>(actionType, async () => {
        clearStorage(storageKey);
    });
}
